import { militaryNameMapping } from 'constants/military-badge-mappings';

/**
 * Gets the display name for a military association
 * @param milnetAssociation - The military association key
 * @returns The display name if valid, null otherwise
 */
export const getMilitaryAssociationDisplayName = (milnetAssociation?: string): string | null => {
  if (!milnetAssociation) return null;
  return milnetAssociation in militaryNameMapping ? militaryNameMapping[milnetAssociation] : null;
};
